import React from 'react';
import { Box } from '@chakra-ui/react';

import { MainPageContent, PageHeading } from '../../common/components';
import { useTranslations } from '../../contexts/LocalizationContext';
import { ReuseCardsTable } from './components/ReuseCardsTable/ReuseCardsTable';

export const ReuseCards = () => {
  const translations = useTranslations();

  return (
    <MainPageContent>
      <PageHeading>{translations('reuse_cards_header')}</PageHeading>
      <Box w="100%" mt={2}>
        <ReuseCardsTable />
      </Box>
    </MainPageContent>
  );
};
